/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MilestoneResponse } from './MilestoneResponse';
import {
    MilestoneResponseFromJSON,
    MilestoneResponseFromJSONTyped,
    MilestoneResponseToJSON,
    MilestoneResponseToJSONTyped,
} from './MilestoneResponse';
import type { QuestReset } from './QuestReset';
import {
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
    QuestResetToJSONTyped,
} from './QuestReset';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';
import type { OWRewardMaxType } from './OWRewardMaxType';
import {
    OWRewardMaxTypeFromJSON,
    OWRewardMaxTypeFromJSONTyped,
    OWRewardMaxTypeToJSON,
    OWRewardMaxTypeToJSONTyped,
} from './OWRewardMaxType';
import type { OWLogCategory } from './OWLogCategory';
import {
    OWLogCategoryFromJSON,
    OWLogCategoryFromJSONTyped,
    OWLogCategoryToJSON,
    OWLogCategoryToJSONTyped,
} from './OWLogCategory';
import type { OWRewardMode } from './OWRewardMode';
import {
    OWRewardModeFromJSON,
    OWRewardModeFromJSONTyped,
    OWRewardModeToJSON,
    OWRewardModeToJSONTyped,
} from './OWRewardMode';

/**
 * 
 * @export
 * @interface OWQuestResponse
 */
export interface OWQuestResponse {
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    game?: string;
    /**
     * The title of the reward.
     * @type {string}
     * @memberof OWQuestResponse
     */
    name: string;
    /**
     * The description of the reward.
     * @type {string}
     * @memberof OWQuestResponse
     */
    description?: string;
    /**
     * If the quest is active (shows on FE and tracks in the BE) or not.
     * @type {boolean}
     * @memberof OWQuestResponse
     */
    isActive: boolean;
    /**
     * If the quest complete notification should be shown.
     * @type {boolean}
     * @memberof OWQuestResponse
     */
    showQuestCompleteNotification?: boolean;
    /**
     * The message to show in the quest complete notification.
     * @type {string}
     * @memberof OWQuestResponse
     */
    questCompleteNotificationMessage?: string;
    /**
     * The maximum amount of reward that can be claimed.
     * @type {number}
     * @memberof OWQuestResponse
     */
    rewardMax?: number;
    /**
     * 
     * @type {OWRewardMaxType}
     * @memberof OWQuestResponse
     */
    rewardMaxType?: OWRewardMaxType;
    /**
     * 
     * @type {OWLogCategory}
     * @memberof OWQuestResponse
     */
    rewardCategory: OWLogCategory;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    eventType: string;
    /**
     * The target amount of progress to reach to claim the reward.
     * @type {number}
     * @memberof OWQuestResponse
     */
    target: number;
    /**
     * 
     * @type {QuestReset}
     * @memberof OWQuestResponse
     */
    questReset?: QuestReset;
    /**
     * 
     * @type {Array<MilestoneResponse>}
     * @memberof OWQuestResponse
     */
    milestones?: Array<MilestoneResponse>;
    /**
     * If the quest is available for all supported games that are not in our database (OWGames).
     * @type {boolean}
     * @memberof OWQuestResponse
     */
    onAllSupportedGames?: boolean;
    /**
     * 
     * @type {OWRewardMode}
     * @memberof OWQuestResponse
     */
    mode?: OWRewardMode;
    /**
     * Ref to the challenge of this quest (only for challenge quests).
     * @type {string}
     * @memberof OWQuestResponse
     */
    challenge?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OWQuestResponse
     */
    isSponsored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    sponsorName?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    rewardImage?: string;
    /**
     * 
     * @type {number}
     * @memberof OWQuestResponse
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof OWQuestResponse
     */
    endAt?: number;
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof OWQuestResponse
     */
    rewardConfigs?: Array<RewardConfigResponse>;
}



/**
 * Check if a given object implements the OWQuestResponse interface.
 */
export function instanceOfOWQuestResponse(value: object): value is OWQuestResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('rewardCategory' in value) || value['rewardCategory'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}

export function OWQuestResponseFromJSON(json: any): OWQuestResponse {
    return OWQuestResponseFromJSONTyped(json, false);
}

export function OWQuestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWQuestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'game': json['game'] == null ? undefined : json['game'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': json['showQuestCompleteNotification'] == null ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': json['questCompleteNotificationMessage'] == null ? undefined : json['questCompleteNotificationMessage'],
        'rewardMax': json['rewardMax'] == null ? undefined : json['rewardMax'],
        'rewardMaxType': json['rewardMaxType'] == null ? undefined : OWRewardMaxTypeFromJSON(json['rewardMaxType']),
        'rewardCategory': OWLogCategoryFromJSON(json['rewardCategory']),
        'eventType': json['eventType'],
        'target': json['target'],
        'questReset': json['questReset'] == null ? undefined : QuestResetFromJSON(json['questReset']),
        'milestones': json['milestones'] == null ? undefined : ((json['milestones'] as Array<any>).map(MilestoneResponseFromJSON)),
        'onAllSupportedGames': json['onAllSupportedGames'] == null ? undefined : json['onAllSupportedGames'],
        'mode': json['mode'] == null ? undefined : OWRewardModeFromJSON(json['mode']),
        'challenge': json['challenge'] == null ? undefined : json['challenge'],
        'isSponsored': json['isSponsored'] == null ? undefined : json['isSponsored'],
        'sponsorName': json['sponsorName'] == null ? undefined : json['sponsorName'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'color': json['color'] == null ? undefined : json['color'],
        'externalUrl': json['externalUrl'] == null ? undefined : json['externalUrl'],
        'rewardImage': json['rewardImage'] == null ? undefined : json['rewardImage'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'rewardConfigs': json['rewardConfigs'] == null ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
    };
}

export function OWQuestResponseToJSON(json: any): OWQuestResponse {
    return OWQuestResponseToJSONTyped(json, false);
}

export function OWQuestResponseToJSONTyped(value?: OWQuestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'game': value['game'],
        'name': value['name'],
        'description': value['description'],
        'isActive': value['isActive'],
        'showQuestCompleteNotification': value['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': value['questCompleteNotificationMessage'],
        'rewardMax': value['rewardMax'],
        'rewardMaxType': OWRewardMaxTypeToJSON(value['rewardMaxType']),
        'rewardCategory': OWLogCategoryToJSON(value['rewardCategory']),
        'eventType': value['eventType'],
        'target': value['target'],
        'questReset': QuestResetToJSON(value['questReset']),
        'milestones': value['milestones'] == null ? undefined : ((value['milestones'] as Array<any>).map(MilestoneResponseToJSON)),
        'onAllSupportedGames': value['onAllSupportedGames'],
        'mode': OWRewardModeToJSON(value['mode']),
        'challenge': value['challenge'],
        'isSponsored': value['isSponsored'],
        'sponsorName': value['sponsorName'],
        'logo': value['logo'],
        'color': value['color'],
        'externalUrl': value['externalUrl'],
        'rewardImage': value['rewardImage'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'rewardConfigs': value['rewardConfigs'] == null ? undefined : ((value['rewardConfigs'] as Array<any>).map(RewardConfigResponseToJSON)),
    };
}

